import { useState } from "react";
import { toast } from "sonner";
import { PaperPlaneRight } from "@phosphor-icons/react";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";

export function ApplicantMessagePanel({ applicant, onSent, testid = "applicant-message" }) {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const messages = applicant?.messages || [];

  const send = async () => {
    if (!message.trim()) { toast.error("Write the message first"); return; }
    setBusy(true);
    try {
      await api.post(`/applicants/${applicant.id}/message`, { subject: subject.trim(), message: message.trim() });
      toast.success(`Email sent to ${applicant.email}`);
      setSubject(""); setMessage("");
      onSent?.();
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };

  return (
    <div className="rounded-xl border border-stone-200 bg-white p-5 shadow-sm" data-testid={`${testid}-panel`}>
      <p className="font-heading text-sm font-semibold text-stone-900">Message {applicant?.name?.split(" ")[0] || "applicant"}</p>
      <p className="mt-0.5 text-xs text-stone-500">Goes to {applicant?.email || "—"} as an email from the office. Logged on the application.</p>
      <div className="mt-3 space-y-3">
        <Input value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Subject (optional)"
          className="border-stone-300 bg-white" data-testid={`${testid}-subject`} />
        <Textarea rows={4} value={message} onChange={(e) => setMessage(e.target.value)}
          placeholder="Write your message…" className="border-stone-300 bg-white" data-testid={`${testid}-body`} />
        <Button onClick={send} disabled={busy || !applicant?.email} size="sm"
          className="rounded-full bg-primary text-primary-foreground hover:bg-stone-900" data-testid={`${testid}-send`}>
          <PaperPlaneRight size={14} className="mr-1.5" /> {busy ? "Sending…" : "Send email"}
        </Button>
        {!applicant?.email && <p className="text-xs text-[#C0392B]">No email address on this application.</p>}
      </div>
      {messages.length > 0 && (
        <div className="mt-4 border-t border-stone-100 pt-3" data-testid={`${testid}-log`}>
          <p className="text-[10px] font-semibold uppercase tracking-wide text-stone-400">Previous messages</p>
          <div className="mt-2 space-y-2">
            {[...messages].reverse().map((m, i) => (
              <div key={i} className="rounded-lg bg-accent/50 px-3 py-2 text-xs text-stone-600">
                <p className="font-medium text-stone-800">{m.subject} <span className="font-normal text-stone-400">· {String(m.at).slice(0, 10)} · {m.by}</span></p>
                <p className="mt-0.5 whitespace-pre-wrap">{m.message}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
